import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SelectItem } from "primeng/api";
import { interval } from "rxjs";
import { MasterscreenService } from "../../../masterscreen/services/masterscreen.service";
import { Login } from "../../../observation/model/login.model";
import { ObservationRequest } from "../../../observation/model/observationData.model";
import { UserPermissionParameters } from "../../../observation/model/userPermission.model";
import { ObservationService } from "../../../observation/services/observation.service";
import { ViewPassRequestComponent } from "../../../person-on-board/components/view-pass-request/view-pass-request.component";
import { BaseService } from "../../../shared/services/base.service";
import { CommonService } from "../../../shared/services/common.service";
import { ConstantsService } from "../../../shared/services/constants.service";
import { HseErrorHandlerService } from "../../../shared/services/hse-error-handler.service";
import { NotificationsService } from "../../../shared/services/notification.service";
import { Document, MasterRequest, Pass, PrerequisteConfiguration, Request } from "../../model/masterrequest.model";
import { POBPermissionDetails } from "../../model/POBPermissions.model";
import { PersononboardConstantsService } from "../../services/persononboard-constants.service";
import { PersononboardService } from "../../services/persononboard.service";
import { PerformanceService } from '../../../performance-dashboard/services/performance.service';

@Component({
  selector: "ara-raise-pass-request",
  templateUrl: "./raise-pass-request.component.html",
  styleUrls: ["./raise-pass-request.component.css"]
})
export class RaisePassRequestComponent implements OnInit {
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  closePopup: boolean = false;
  forValue: Date;
  toValue: Date;
  selectedValueForReceived: string;
  CompanyId: number;
  LocationId: number;
  @ViewChild(ViewPassRequestComponent, { static: true }) viewPassRequestComponent: ViewPassRequestComponent;
  currentPassId: number = 1;
  tempPassId: any;
  passRequestForData: MasterRequest;
  passRequestForDataResponse: MasterRequest[] = [];
  passRequestForFormData: Request;
  preRequisiteConfigurationId: number;
  errorDetails: any;
  isOffice: any;
  unitTree: any;
  selectedUnit: any;
  permissions: POBPermissionDetails;
  UnitName: string;
  UnitId: number;
  confirmMessage: string;
  isOnline: boolean = false;
  offlineRoutes: any;
  dialogHeight: string;
  dialogWidth: string;
  UnitType: string;
  contracts: { label: string; value: string }[] = [];
  unitContractDetails: any[] = [];
  isHasContractDetails: boolean = true;
  selectedContract: number = 0;
  hideContract : boolean=true;
  showContractValidation : boolean=false;
  isUnitEmployee:boolean=true;
  ContractId:number = 0;
  ContractNumber:string;
  constructor(
    private hseErrorHandler: HseErrorHandlerService,
    private masterscreenService: MasterscreenService,
    private baseService: BaseService,
    private router: Router,
    private pobServices: PersononboardService,
    private observationService: ObservationService,
    private commonService: CommonService,
    private notificationsService: NotificationsService,
    private PDService: PerformanceService,
    private translate: TranslateService
  ) {
    this.passRequestForData = new MasterRequest();
  }
  entries = [];
  selectedEntry: string = "";
  login: Login;
  isDisplayObservationType: boolean = true;
  company: any[] = [];
  companys: any[] = [];
  location: SelectItem[] = [];
  locations: any[] = [];
  selectedCompany: string;
  selectedLocation: string;
  passTypeRowNameValue: string;
  passTypeRowIdValue: number;
  observationData: ObservationRequest;
  loggedInUserJSON: any;
  validate: boolean = true;
  isIncidentReportErrorMsg: boolean = false;

  masterRequest: MasterRequest;
  Request: Request;
  Pass: Pass;
  document: Document;
  CompanyName: string;
  LocationName: string;
  PassTypeDetails: any[] = [];
  dataFromPassRequestForm: any[] = [];
  alertType: any;
  successDetails: string;
  preReqConfigurationRequest: PrerequisteConfiguration[] = [];

  ngOnInit() {
    this.checkedOnlineStatus();
    if (navigator.onLine) {
      const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
      this.loggedInUserJSON = JSON.parse(loggedInUser);
      this.login = new Login();
      this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
      this.login.ID = this.loggedInUserJSON.UserId;
      const apiRequest = {
        Model: {
          GetActiveNodes: true,
          UserId: this.loggedInUserJSON.UserId
        }
      };
      this.masterscreenService.getTreeData(
        apiRequest,
        this.callbackMethodForGetTreeData.bind(this)
      );
      const routes = JSON.stringify(PersononboardConstantsService.PersonOnBoardUrl.InnerRoutes);
      const routesFlag = JSON.parse(routes);
      const independentPermission = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
      if (!independentPermission.POB_SecurityCheckInOut && !independentPermission.POB_Admin && !independentPermission.POB_Admin_Unit) {
        for (let index = 0; index < routesFlag.length; index++) {
          if (routesFlag[index].routeName === 'Check In/Out') {
            this.routesFlag = [...routesFlag.splice(index, 1)];
            break;
          }
        }
      }

      this.reportRoutes = PersononboardConstantsService.PersonOnBoardUrl.ReportRoutes;
      this.currentPassId = 1;
      this.dataFromPassRequestForm = this.viewPassRequestComponent.SaveAndContinueResponse;
      this.baseService.setClosePopUpListener.subscribe(data => {
        this.closePopup = false;
      });
      this.preReqConfigurationRequest = [];
      this.permissions = new POBPermissionDetails();
      this.baseService.translatorListener.subscribe(data => {
        this.translate.use(data);
      });
    } else {
      const routes = JSON.stringify(
        PersononboardConstantsService.PersonOnBoardUrl.OfflineRoutes
      );
      this.routesFlag = JSON.parse(routes);
      this.baseService.setItemInSession(
        "offlineSplicedRoutes",
        JSON.stringify(this.routesFlag)
      );
      this.getOfflineData();
    }
  }
  getOfflineData() {
    this.offlineRoutes = JSON.parse(
      this.baseService.getItemFromSession("offlineSplicedRoutes")
    );
    if (this.offlineRoutes !== null) {
      this.routesFlag = this.offlineRoutes;
    }
  }
  checkedOnlineStatus() {
    const repeatCheck = interval(1000);
    repeatCheck.subscribe(val => {
      if (navigator.onLine) {
        this.isOnline = true;
      } else {
        this.isOnline = false;
      }
    });
  }
  callbackMethodForGetTreeData(response) {
    if (response.Result !== null) {
      this.unitTree = response.Result;
      this.unitTree.forEach(element => {
        this.compareTreeNode(element, 0);
      });
    }
  }
  compareTreeNode(node, selectedNode) {
    if (!node.IsActive) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.children && node.children.length > 0) {
      node.selectable = false;
      node.children.forEach(element => {
        if (!element.IsActive) {
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
      });
    }
  }
  getUserPermissions() {
    const userPermissionParameters = new UserPermissionParameters();
    userPermissionParameters.UserId = this.loggedInUserJSON.UserId;
    userPermissionParameters.ModuleId =
      ConstantsService.PermissionMatrixModules.POB;
    userPermissionParameters.UnitId = this.selectedUnit.id;
    const apiRequest = {
      Model: userPermissionParameters
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForGetUserPermissions.bind(this)
    );
  }
  callbackMethodForGetUserPermissions(response) {
    this.permissions = response.Result.POBPermission;
    this.getLocation();
  }
  // Shows error message when service is not available ( WebAPIs are not in running mode)
  serviceError() {
    this.hseErrorHandler.handleError(
      "Service (WebAPI) is not available or not in running mode"
    );
  }
  showDialog(passTypeRowName, passTypeRowId) {
     
    this.UnitName = this.selectedUnit.label;
    this.UnitId = this.selectedUnit.id;
    this.locations.forEach(location => {
      if (location.LocationId === this.selectedLocation) {
        this.LocationName = location.LocationName;
        this.LocationId = location.LocationId;
        this.isOffice = location.IsOffice;
      }
    });
    this.passTypeRowNameValue = passTypeRowName;
    this.passTypeRowIdValue = passTypeRowId;
    this.tempPassId = this.currentPassId;
    //this.currentPassId = this.currentPassId+1;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.getUsersByUsageType();
  }
  setPassRequesRaised(data) {
    this.viewPassRequestComponent.checkPassRequestRaised(data);
  }

  // method to get company name
  getcompany() {
    this.masterscreenService.getCompanyDetails(
      null,
      this.callbackMethodForgetCompanyData.bind(this)
    );
  }

  // call back method of company name
  callbackMethodForgetCompanyData(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response) {
      this.companys = response;
      const companyDetails = response;
      companyDetails.forEach(company => {
        this.company.push({
          label: company.CompanyName,
          value: company.CompanyId
        });
      });
    }
  }

  getLocation() {
    this.login.CompanyId = 0;
    this.login.UnitId = this.selectedUnit.UnitId;
    const apiRequest = {
      Model: {
        ...this.login,
        GetActiveLocations: true
      }
    };
    this.observationService.getLocationData(
      apiRequest,
      this.callbackMethodForgetLocationData.bind(this)
    );
  }

  // call back method of location name
  callbackMethodForgetLocationData(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response) {
      this.location = [];
      this.locations = response.Result;
      const locationDetails = response.Result;
      locationDetails.forEach(location => {
        this.location.push({
          label: location.LocationName,
          value: location.LocationId
        });
      });
    }
    this.getPassType();
  }
  // method to get pass type
  getPassType() {
    this.masterscreenService.getPassTypeDetailsData(
      null,
      this.callbackMethodtogetpasstypedetails.bind(this)
    );
  }

  // call back method of Pass Type
  callbackMethodtogetpasstypedetails(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response) {
      this.PassTypeDetails = response.Result;
      this.PassTypeDetails.forEach(element => {
        element.Disabled = true;
      });
      this.PassTypeDetails.forEach(element => {
        if (element.PassTypeName === "Staff" && (this.permissions.POB_Staff_Add || this.permissions.POB_Staff_Add_Unit || this.permissions.POB_Admin)) {
          element.Disabled = false;
        }
        if (element.PassTypeName === "Contractor" && (this.permissions.POB_Contractor_Add || this.permissions.POB_Contractor_Add_Unit || this.permissions.POB_Admin)) {
          element.Disabled = false;
        }
      });
    }
  }

  submitPasses() {
    if (this.dataFromPassRequestForm.length > 0) {
      this.submitRaisePassRequest();
    }
  }
  submitRaisePassRequest() {
    this.baseService.showRootLoader = true;
    this.preReqConfigurationRequest = this.viewPassRequestComponent.preReqConfigurationRequest;
    this.passRequestForData.MasterUnitId = this.UnitId;
    this.passRequestForData.MasterLocationId = this.LocationId;
    this.passRequestForData.PassTypeId = this.passTypeRowIdValue;
    this.passRequestForData.IsOffice = this.isOffice;
    this.passRequestForData.Requests = this.dataFromPassRequestForm;
    this.preReqConfigurationRequest.forEach(element => {
      if (
        element.UnitId === this.passRequestForData.MasterUnitId &&
        element.LocationId === this.passRequestForData.MasterLocationId &&
        element.PassTypeId === this.passRequestForData.PassTypeId
      ) {
        this.passRequestForData.PreRequisiteConfigurationId =
          element.PreRequisiteConfigurationId;
      }
    });
    this.passRequestForData.PassTypeId = this.passTypeRowIdValue;
    this.passRequestForData.RaisedBy = this.loggedInUserJSON.UserId;
    this.passRequestForData.IsDraft = false;
   // this.passRequestForData.UserId = this.viewPassRequestComponent.UserId;//Pritesh
    const apiRequest = {
      Model: this.passRequestForData
    };
    this.pobServices.SaveorUpdatePassRequest(
      apiRequest,
      this.callbackMethodForSubmitRaisePassRequest.bind(this)
    );
  }
  callbackMethodForSubmitRaisePassRequest(response) {
    this.baseService.showRootLoader = false;
    if (response && response.Success) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Pass Request submitted successfully"
      );
      this.router.navigate(["pob/pass-request-overview"]);
    } else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "something went wrong!"
      );
    }
    this.baseService.showRootLoader = false;
  }
  checkValid() {
    if (!this.dataFromPassRequestForm) {
      this.isIncidentReportErrorMsg = true;
      this.validate = false;
    } else {
      this.validate = true;
    }
  }
  onYesClickedSuccess() {
    this.alertType = null;
    this.successDetails = null;
    this.closePopup = false;
    this.router.navigate(["pob/pass-request-overview"]);
  }
  closePopUp() {
    this.viewPassRequestComponent.resetValue();
    this.closePopup = false;
  }
  changeLocation(selectedCompany) {
    this.companys.forEach(company => {
      if (company.CompanyId === this.selectedCompany) {
        this.CompanyName = company.CompanyName;
        this.CompanyId = company.CompanyId;
      }
    });
    this.getLocation();
  }
  nodeSelected(event) {
    this.selectedUnit = event.node;
    if (this.selectedUnit.children && this.selectedUnit.children.length > 0) {
      this.selectedUnit.expanded = true;
    }
    this.getUserPermissions();
    this.selectedContract = 0;
    if(this.selectedUnit.UnitTypeId == 2)
    {
      this.isUnitEmployee = false;
    }
    else
    {
      this.isUnitEmployee = true;
      this.passRequestForData.Contract = 0;
      this.ContractId = 0;
      this.ContractNumber = "";
    }   
    this.getContractDetails(this.selectedUnit.UnitId);
  }
  onYesClickedForConfirmation() { }
  onNoClickedForConfirmation() { }

  getUsersByUsageType() {
    const apiRequest = {
      Model: {
        ModuleId: ConstantsService.PermissionMatrixModules.POB,
        UnitId: this.UnitId,
        AdditionalFilter: this.passTypeRowNameValue
      }
    }
    this.commonService.getUsersByUsageType(apiRequest, this.callbackMethodForGetUsersByUsageType.bind(this));
  }

  callbackMethodForGetUsersByUsageType(response) {
    if (response.Success) {
      if (response && response.Result.length) {
        this.closePopup = true;
        this.setPassRequesRaised(this);
      }
    }
    else {
      this.notificationsService.toastNotify('error', 'Error Message', response.Errors[0].Message + ' permission is not set for selected Unit.');
    }
  }

 
  saveAsDraft() {
    if (this.dataFromPassRequestForm.length > 0) {
    this.baseService.showRootLoader = true;
    this.preReqConfigurationRequest = this.viewPassRequestComponent.preReqConfigurationRequest;
    this.passRequestForData.MasterUnitId = this.UnitId;
    this.passRequestForData.MasterLocationId = this.LocationId;
    this.passRequestForData.PassTypeId = this.passTypeRowIdValue;
    this.passRequestForData.IsOffice = this.isOffice;
    this.passRequestForData.Requests = this.dataFromPassRequestForm;
    this.preReqConfigurationRequest.forEach(element => {
      if (
        element.UnitId === this.passRequestForData.MasterUnitId &&
        element.LocationId === this.passRequestForData.MasterLocationId &&
        element.PassTypeId === this.passRequestForData.PassTypeId
      ) {
        this.passRequestForData.PreRequisiteConfigurationId =
          element.PreRequisiteConfigurationId;
      }
    });
    this.passRequestForData.PassTypeId = this.passTypeRowIdValue;
    this.passRequestForData.RaisedBy = this.loggedInUserJSON.UserId;
    this.passRequestForData.IsDraft = true;
    const apiRequest = {
      Model: this.passRequestForData
    };
    this.pobServices.SaveorUpdatePassRequest(
      apiRequest,
      this.callbackMethodForSubmitRaisePassRequest.bind(this)
    );
  }
  }

  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        "UnitId": unitId
      },
    };
    this.PDService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this)
    );
  }

  callbackMethodForContractDetails(response) {
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach(contract => {
      this.contracts.push({ label: contract.ContractNumber, value: contract.UnitContractDetailsId });
    });
   
  }

  checkHolder(event) {
    let contract;
    contract = this.unitContractDetails.find(contract => contract.UnitContractDetailsId === event.value);
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isHasContractDetails = true;
    } else {
      this.isHasContractDetails = false;
    }
    this.passRequestForData.Contract = event.value;
    this.showContractValidation = false;
    this.ContractId = event.value;
    this.ContractNumber = contract.ContractNumber != undefined ? contract.ContractNumber : "";
  }

}

export class columns {
  field: string;
}
export class Status {
  Id: number;
  Value: string;
}
